module.exports = __webpack_public_path__ + "static/media/press-pops-logo.ccfa5d79.png";